import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { provideRouter, Router, withPreloading } from '@angular/router';
import { routes } from './app/app-routing.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { NgxStripeModule } from 'ngx-stripe';
import { CustomPreloadingStrategy } from './app/services/custom-preloading-strategy';
import { scheduleDeferredObservability } from './app/bootstrap/observability';
import { authInterceptor } from './app/shared/interceptors/auth.interceptor';
import { provideAuth } from 'angular-auth-oidc-client';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes, withPreloading(CustomPreloadingStrategy)),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAuth({
      config: {
        authority: environment.oidcAuthority,
        redirectUrl: environment.oidcRedirectUrl,
        postLogoutRedirectUri: environment.oidcPostLogoutRedirectUrl,
        clientId: environment.oidcClientId,
        scope: 'openid profile email urn:zitadel:iam:org:project:id:zitadel:aud',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        autoUserInfo: false,
        disableIdTokenValidation: true,
      },
    }),
    importProvidersFrom(NgxStripeModule.forRoot(environment.stripe_publishable_key)),
  ],
})
  .then(appRef => {
    scheduleDeferredObservability({
      enabled: environment.production,
      injector: appRef.injector,
      router: appRef.injector.get(Router),
      document,
    });

    return appRef;
  })
  .catch(err => console.error(err));
